function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

import _regeneratorRuntime from "@babel/runtime/regenerator";

var _marked = /*#__PURE__*/_regeneratorRuntime.mark(getCopyOnEnterAttributes);

function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e) { throw _e; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e2) { didErr = true; err = _e2; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */
import { Command, Plugin } from '@ckeditor/ckeditor5-core/dist/index.js';
import { Observer, BubblingEventInfo, DomEventData } from '@ckeditor/ckeditor5-engine/dist/index.js';
import { env } from '@ckeditor/ckeditor5-utils/dist/index.js';
/**
 * @license Copyright (c) 2003-2024, CKSource Holding sp. z o.o. All rights reserved.
 * For licensing, see LICENSE.md or https://ckeditor.com/legal/ckeditor-oss-license
 */

/**
* @module enter/utils
*/

/**
* Returns attributes that should be preserved on the enter keystroke.
*
* Filtering is realized based on `copyOnEnter` attribute property. Read more about attribute properties
* {@link module:engine/model/schema~Schema#setAttributeProperties here}.
*
* @param schema Model's schema.
* @param allAttributes Attributes to filter.
*/

function getCopyOnEnterAttributes(schema, allAttributes) {
  var _iterator, _step, attribute;

  return _regeneratorRuntime.wrap(function getCopyOnEnterAttributes$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          _iterator = _createForOfIteratorHelper(allAttributes);
          _context.prev = 1;

          _iterator.s();

        case 3:
          if ((_step = _iterator.n()).done) {
            _context.next = 10;
            break;
          }

          attribute = _step.value;

          if (!(attribute && schema.getAttributeProperties(attribute[0]).copyOnEnter)) {
            _context.next = 8;
            break;
          }

          _context.next = 8;
          return attribute;

        case 8:
          _context.next = 3;
          break;

        case 10:
          _context.next = 15;
          break;

        case 12:
          _context.prev = 12;
          _context.t0 = _context["catch"](1);

          _iterator.e(_context.t0);

        case 15:
          _context.prev = 15;

          _iterator.f();

          return _context.finish(15);

        case 18:
        case "end":
          return _context.stop();
      }
    }
  }, _marked, null, [[1, 12, 15, 18]]);
}
/**
 * Enter command used by the {@link module:enter/enter~Enter Enter feature} to handle the <kbd>Enter</kbd> keystroke.
 */


var EnterCommand = /*#__PURE__*/function (_Command) {
  _inherits(EnterCommand, _Command);

  var _super = _createSuper(EnterCommand);

  function EnterCommand() {
    _classCallCheck(this, EnterCommand);

    return _super.apply(this, arguments);
  }

  _createClass(EnterCommand, [{
    key: "execute",
    value:
    /**
    * @inheritDoc
    */
    function execute() {
      var _this = this;

      this.editor.model.change(function (writer) {
        _this.enterBlock(writer);

        _this.fire('afterExecute', {
          writer: writer
        });
      });
    }
    /**
    * Splits a block where the document selection is placed, in the way how the <kbd>Enter</kbd> key is expected to work:
    *
    * ```
    * <p>Foo[]bar</p>   ->   <p>Foo</p><p>[]bar</p>
    * <p>Foobar[]</p>   ->   <p>Foobar</p><p>[]</p>
    * <p>Fo[ob]ar</p>   ->   <p>Fo</p><p>[]ar</p>
    * ```
    *
    * In some cases, the split will not happen:
    *
    * ```
    * // The selection parent is a limit element:
    * <figcaption>A[bc]d</figcaption>   ->   <figcaption>A[]d</figcaption>
    *
    * // The selection spans over multiple elements:
    * <h>x[x</h><p>y]y<p>   ->   <h>x</h><p>[]y</p>
    * ```
    *
    * @param writer Writer to use when performing the enter action.
    * @returns Boolean indicating if the block was split.
    */

  }, {
    key: "enterBlock",
    value: function enterBlock(writer) {
      var model = this.editor.model;
      var selection = model.document.selection;
      var schema = model.schema;
      var isSelectionEmpty = selection.isCollapsed;
      var range = selection.getFirstRange();
      var startElement = range.start.parent;
      var endElement = range.end.parent; // Don't touch the roots and other limit elements.

      if (schema.isLimit(startElement) || schema.isLimit(endElement)) {
        // Delete the selected content but only if inside a single limit element.
        // Abort, when crossing limit elements boundary (e.g. <limit1>x[x</limit1>donttouchme<limit2>y]y</limit2>).
        // This is an edge case and it's hard to tell what should actually happen because such a selection
        // is not entirely valid.
        if (!isSelectionEmpty && startElement == endElement) {
          model.deleteContent(selection);
        }

        return false;
      }

      if (isSelectionEmpty) {
        var attributesToCopy = getCopyOnEnterAttributes(writer.model.schema, selection.getAttributes());
        splitBlock(writer, range.start);
        writer.setSelectionAttribute(attributesToCopy);
        return true;
      } else {
        var leaveUnmerged = !(range.start.isAtStart && range.end.isAtEnd);
        var isContainedWithinOneElement = startElement == endElement;
        model.deleteContent(selection, {
          leaveUnmerged: leaveUnmerged
        });

        if (leaveUnmerged) {
          // Partially selected elements.
          //
          // <h>x[xx]x</h>		-> <h>x^x</h>			-> <h>x</h><h>^x</h>
          if (isContainedWithinOneElement) {
            splitBlock(writer, selection.focus);
            return true;
          } else {
            writer.setSelection(endElement, 0);
          }
        }
      }

      return false;
    }
  }]);

  return EnterCommand;
}(Command);

function splitBlock(writer, splitPos) {
  writer.split(splitPos);
  writer.setSelection(splitPos.parent.nextSibling, 0);
}

var ENTER_EVENT_TYPES = {
  insertParagraph: {
    isSoft: false
  },
  insertLineBreak: {
    isSoft: true
  }
};
/**
 * Enter observer introduces the {@link module:engine/view/document~Document#event:enter `Document#enter`} event.
 */

var EnterObserver = /*#__PURE__*/function (_Observer) {
  _inherits(EnterObserver, _Observer);

  var _super2 = _createSuper(EnterObserver);

  /**
  * @inheritDoc
  */
  function EnterObserver(view) {
    var _this2;

    _classCallCheck(this, EnterObserver);

    _this2 = _super2.call(this, view);
    var doc = _this2.document;
    var shiftPressed = false;
    doc.on('keydown', function (evt, data) {
      shiftPressed = data.shiftKey;
    });
    doc.on('beforeinput', function (evt, data) {
      if (!_this2.isEnabled) {
        return;
      }

      var inputType = data.inputType; // See https://github.com/ckeditor/ckeditor5/issues/13321.

      if (env.isSafari && shiftPressed && inputType == 'insertParagraph') {
        inputType = 'insertLineBreak';
      }

      var domEvent = data.domEvent;
      var enterEventSpec = ENTER_EVENT_TYPES[inputType];

      if (!enterEventSpec) {
        return;
      }

      var event = new BubblingEventInfo(doc, 'enter', data.targetRanges[0]);
      doc.fire(event, new DomEventData(view, domEvent, {
        isSoft: enterEventSpec.isSoft
      })); // Stop `beforeinput` event if `enter` event was stopped.
      // https://github.com/ckeditor/ckeditor5/issues/753

      if (event.stop.called) {
        evt.stop();
      }
    });
    return _this2;
  }
  /**
  * @inheritDoc
  */


  _createClass(EnterObserver, [{
    key: "observe",
    value: function observe() {}
    /**
    * @inheritDoc
    */

  }, {
    key: "stopObserving",
    value: function stopObserving() {}
  }]);

  return EnterObserver;
}(Observer);
/**
 * This plugin handles the <kbd>Enter</kbd> keystroke (hard line break) in the editor.
 *
 * See also the {@link module:enter/shiftenter~ShiftEnter} plugin.
 *
 * For more information about this feature see the {@glink api/enter package page}.
 */


var Enter = /*#__PURE__*/function (_Plugin) {
  _inherits(Enter, _Plugin);

  var _super3 = _createSuper(Enter);

  function Enter() {
    _classCallCheck(this, Enter);

    return _super3.apply(this, arguments);
  }

  _createClass(Enter, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var view = editor.editing.view;
      var viewDocument = view.document;
      var t = this.editor.t;
      view.addObserver(EnterObserver);
      editor.commands.add('enter', new EnterCommand(editor));
      this.listenTo(viewDocument, 'enter', function (evt, data) {
        // When not in composition, we handle the action, so prevent the default one.
        // When in composition, it's the browser who modify the DOM (renderer is disabled).
        if (!viewDocument.isComposing) {
          data.preventDefault();
        } // The soft enter key is handled by the ShiftEnter plugin.


        if (data.isSoft) {
          return;
        }

        editor.execute('enter');
        view.scrollToTheSelection();
      }, {
        priority: 'low'
      }); // Add the information about the keystroke to the accessibility database.

      editor.accessibility.addKeystrokeInfos({
        keystrokes: [{
          label: t('Insert a hard break (a new paragraph)'),
          keystroke: 'Enter'
        }]
      });
    }
  }], [{
    key: "pluginName",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return 'Enter';
    }
  }]);

  return Enter;
}(Plugin);
/**
 * ShiftEnter command. It is used by the {@link module:enter/shiftenter~ShiftEnter ShiftEnter feature} to handle
 * the <kbd>Shift</kbd>+<kbd>Enter</kbd> keystroke.
 */


var ShiftEnterCommand = /*#__PURE__*/function (_Command2) {
  _inherits(ShiftEnterCommand, _Command2);

  var _super4 = _createSuper(ShiftEnterCommand);

  function ShiftEnterCommand() {
    _classCallCheck(this, ShiftEnterCommand);

    return _super4.apply(this, arguments);
  }

  _createClass(ShiftEnterCommand, [{
    key: "execute",
    value:
    /**
    * @inheritDoc
    */
    function execute() {
      var _this3 = this;

      var model = this.editor.model;
      var doc = model.document;
      model.change(function (writer) {
        softBreakAction(model, writer, doc.selection);

        _this3.fire('afterExecute', {
          writer: writer
        });
      });
    }
    /**
    * @inheritDoc
    */

  }, {
    key: "refresh",
    value: function refresh() {
      var model = this.editor.model;
      var doc = model.document;
      this.isEnabled = isEnabled(model.schema, doc.selection);
    }
  }]);

  return ShiftEnterCommand;
}(Command);
/**
 * Checks whether the ShiftEnter command should be enabled in the specified selection.
 */


function isEnabled(schema, selection) {
  // At this moment it is okay to support single range selections only.
  // But in the future we may need to change that.
  if (selection.rangeCount > 1) {
    return false;
  }

  var anchorPos = selection.anchor; // Check whether the break element can be inserted in the current selection anchor.

  if (!anchorPos || !schema.checkChild(anchorPos, 'softBreak')) {
    return false;
  }

  var range = selection.getFirstRange();
  var startElement = range.start.parent;
  var endElement = range.end.parent; // Do not modify the content if selection is cross-limit elements.

  if ((isInsideLimitElement(startElement, schema) || isInsideLimitElement(endElement, schema)) && startElement !== endElement) {
    return false;
  }

  return true;
}
/**
 * Creates a break in the way that the <kbd>Shift</kbd>+<kbd>Enter</kbd> keystroke is expected to work.
 */


function softBreakAction(model, writer, selection) {
  var isSelectionEmpty = selection.isCollapsed;
  var range = selection.getFirstRange();
  var startElement = range.start.parent;
  var endElement = range.end.parent;
  var isContainedWithinOneElement = startElement == endElement;

  if (isSelectionEmpty) {
    var attributesToCopy = getCopyOnEnterAttributes(model.schema, selection.getAttributes());
    insertBreak(model, writer, range.end);
    writer.removeSelectionAttribute(selection.getAttributeKeys());
    writer.setSelectionAttribute(attributesToCopy);
  } else {
    var leaveUnmerged = !(range.start.isAtStart && range.end.isAtEnd);
    model.deleteContent(selection, {
      leaveUnmerged: leaveUnmerged
    }); // Selection within one element:
    //
    // <h>x[xx]x</h>		-> <h>x^x</h>			-> <h>x<br>^x</h>

    if (isContainedWithinOneElement) {
      insertBreak(model, writer, selection.focus);
    } else {
      // Move the selection to the 2nd element (last step of the example above).
      if (leaveUnmerged) {
        writer.setSelection(endElement, 0);
      }
    }
  }
}

function insertBreak(model, writer, position) {
  var breakLineElement = writer.createElement('softBreak');
  model.insertContent(breakLineElement, position);
  writer.setSelection(breakLineElement, 'after');
}
/**
 * Checks whether the specified `element` is a child of the limit element.
 *
 * Checking whether the `<p>` element is inside a limit element:
 *   - `<$root><p>Text.</p></$root> => false`
 *   - `<$root><limitElement><p>Text</p></limitElement></$root> => true`
 */


function isInsideLimitElement(element, schema) {
  // `$root` is a limit element but in this case is an invalid element.
  if (element.is('rootElement')) {
    return false;
  }

  return schema.isLimit(element) || isInsideLimitElement(element.parent, schema);
}
/**
 * This plugin handles the <kbd>Shift</kbd>+<kbd>Enter</kbd> keystroke (soft line break) in the editor.
 *
 * See also the {@link module:enter/enter~Enter} plugin.
 *
 * For more information about this feature see the {@glink api/enter package page}.
 */


var ShiftEnter = /*#__PURE__*/function (_Plugin2) {
  _inherits(ShiftEnter, _Plugin2);

  var _super5 = _createSuper(ShiftEnter);

  function ShiftEnter() {
    _classCallCheck(this, ShiftEnter);

    return _super5.apply(this, arguments);
  }

  _createClass(ShiftEnter, [{
    key: "init",
    value: function init() {
      var editor = this.editor;
      var schema = editor.model.schema;
      var conversion = editor.conversion;
      var view = editor.editing.view;
      var viewDocument = view.document;
      var t = this.editor.t; // Configure the schema.

      schema.register('softBreak', {
        allowWhere: '$text',
        isInline: true
      }); // Configure converters.

      conversion.for('upcast').elementToElement({
        model: 'softBreak',
        view: 'br'
      });
      conversion.for('downcast').elementToElement({
        model: 'softBreak',
        view: function view(modelElement, _ref) {
          var writer = _ref.writer;
          return writer.createEmptyElement('br');
        }
      });
      view.addObserver(EnterObserver);
      editor.commands.add('shiftEnter', new ShiftEnterCommand(editor));
      this.listenTo(viewDocument, 'enter', function (evt, data) {
        // When not in composition, we handle the action, so prevent the default one.
        // When in composition, it's the browser who modify the DOM (renderer is disabled).
        if (!viewDocument.isComposing) {
          data.preventDefault();
        } // The hard enter key is handled by the Enter plugin.


        if (!data.isSoft) {
          return;
        }

        editor.execute('shiftEnter');
        view.scrollToTheSelection();
      }, {
        priority: 'low'
      }); // Add the information about the keystroke to the accessibility database.

      editor.accessibility.addKeystrokeInfos({
        keystrokes: [{
          label: t('Insert a soft break (a <code>&lt;br&gt;</code> element)'),
          keystroke: 'Shift+Enter'
        }]
      });
    }
  }], [{
    key: "pluginName",
    get:
    /**
    * @inheritDoc
    */
    function get() {
      return 'ShiftEnter';
    }
  }]);

  return ShiftEnter;
}(Plugin);

export { Enter, ShiftEnter };